import { createBrowserClient } from "@supabase/ssr";
import type { SupabaseClient } from "@supabase/supabase-js";
import { resolveSupabasePublicEnv } from "@/lib/supabase-public-env";

let cachedClient: SupabaseClient | null = null;

/**
 * Lazy browser Supabase client for auth actions (OAuth, password sign-in).
 * Do not call during render — avoids hydration issues if env is missing.
 */
export function getSupabaseBrowserClient(): SupabaseClient | null {
  const env = resolveSupabasePublicEnv();
  if (!env) return null;

  if (!cachedClient) {
    cachedClient = createBrowserClient(env.url, env.anonKey, {
      cookieOptions: {
        path: "/",
        sameSite: "lax",
        secure: process.env.NODE_ENV === "production",
      },
    });
  }

  return cachedClient;
}

/** @deprecated Prefer getSupabaseBrowserClient() inside event handlers. */
export function createClient() {
  const client = getSupabaseBrowserClient();
  if (!client) {
    throw new Error(
      "Supabase is not configured. Set NEXT_PUBLIC_SUPABASE_URL and NEXT_PUBLIC_SUPABASE_ANON_KEY."
    );
  }
  return client;
}
